import { Dispatch, SetStateAction, useEffect, useState } from "react";

export function useStorage<T>(key: string, defaultValue: T): [T, Dispatch<SetStateAction<T>>] {
  const [value, _setValue] = useState<T>("" as T);

  const setValue = (data: any) => {
    if (data === undefined) {
      window.localStorage.removeItem(key)
      _setValue(defaultValue as T);
      return;
    }

    window.localStorage.setItem(key, JSON.stringify(data));
    _setValue(data);
  }

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const isObject = (val: string) => {
      try {
        JSON.parse(val);
        return true;
      } catch (e) {
        return false;
      }
    };

    try {
      const valueData = window.localStorage.getItem(key);
      if (valueData === null) {
        window.localStorage.setItem(key, JSON.stringify(defaultValue));
        return;
      }
      const data = isObject(valueData) ? JSON.parse(valueData) : valueData;
      _setValue(data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  return [value, setValue];
}
